export interface ITextIconLabel {
  emit: boolean;
  id: string;
  label: string;
  upgradeStatus: string;
  upgradeClass: string;
  upgradeInfo?: string;
  matIcon: string;
  sublabel: string;
}

export enum FIRMWARE_AGENT_TYPE {
  VIRTUAL = 'vnf',
  HARDWARE = 'hardware',
  WINDOWS = 'windows'
}

export enum LAST_UPGRADE_MESSAGE {
  started = 'Upgrade Started',
  success = 'Upgrade Successful',
  failed = 'Upgrade Failed'
}

export enum UPGRADE_DISPLAY_MESSAGE {
  success = 'upgraded',
  failed = 'upgrade failed',
  upgrading = 'upgrading',
  available = 'upgrade available',
  updateAvailable = 'update available'
}

export enum SUB_STATUS {
  upgrade = 'upgrade',
  ready = 'ready',
  failed = 'failed'
}

export enum DISCOVERY_TYPES {
  discovery = 'discovery',
  broadcast = 'broadcastDiscovery',
  ztp = 'ztp-config',
}

export enum DISCOVERY_MODE {
  normal = "normal",
  boradcast = "IP-1"
}
